/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Usage_Status_OutsideInputs */



/**
* | output |
* | --- |
* | "outside any billing month" |
*
* @param {Admin_Export_Usage_Status_OutsideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_status_outside = /** @type {((inputs?: Admin_Export_Usage_Status_OutsideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_Status_OutsideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("außerhalb jedes Abrechnungsmonats")
	return /** @type {LocalizedString} */ ("outside any billing month")
});